import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PatchAnnouncementPayload, PatchAnnouncementResponse, PatchStatusAcceptPayload } from '@edtech-ui/core/models/material-upload/announcement-patch-api';
import { GetAllMaterialReceviedResponse, GetAllMaterialResponse } from '@edtech-ui/core/models/material-upload/get-all-materials';
import { StudyMaterialResponse } from '@edtech-ui/core/models/material-upload/get-all-study-material';
import { StudentStudyMaterialResponse } from '@edtech-ui/core/models/material-upload/get-student-all-announcement';
import { MaterialUploadResponse } from '@edtech-ui/core/models/material-upload/material-upload-file';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, Subject, tap } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class AnnouncementService {

	apiUrl = environment.announcementApiUrl;
	reload$ = new Subject<void>();
	announcementId = new BehaviorSubject<number>(0);

	constructor(private readonly http: HttpClient) { }

	postMaterial(formData:FormData): Observable<MaterialUploadResponse> {
		return this.http.post<MaterialUploadResponse>(`${this.apiUrl}/create`, formData)
	}

	getAllMaterialByClassId(classroomId: number, isMaterialSent: boolean=true): Observable<GetAllMaterialResponse> {
		const params = new HttpParams().set('class_id', classroomId).set('is_sent',isMaterialSent);
		return this.http.get<GetAllMaterialResponse>(`${this.apiUrl}/`, { params });
	}

	getAllMaterialByClassIdReceived(classroomId: number, isMaterialSent: boolean=false): Observable<GetAllMaterialReceviedResponse> {
		const params = new HttpParams().set('class_id', classroomId).set('is_sent', isMaterialSent);
		return this.http.get<GetAllMaterialReceviedResponse>(`${this.apiUrl}/`, { params });
	}

	deleteMaterialById(announcementId: number): Observable<PatchAnnouncementResponse<null>> {
		return this.http.patch<PatchAnnouncementResponse<null>>(`${this.apiUrl}/${announcementId}`, {}).pipe(
			tap(() => this.reload$.next())
		);
	}

	updateAnnouncement(payload: PatchAnnouncementPayload): Observable<PatchAnnouncementResponse<any>> {
		return this.http.patch<PatchAnnouncementResponse<any>>(`${this.apiUrl}/update`, payload).pipe(
			tap(() => this.reload$.next())
		);
	}

	updateAcceptAnnouncementStatus(payload: PatchStatusAcceptPayload): Observable<PatchAnnouncementResponse<any>> {
		return this.http.patch<PatchAnnouncementResponse<any>>(`${this.apiUrl}/status`, payload).pipe(
			tap(()=> this.reload$.next())
		);
	}

	getAllStudyMaterialAnnouncement(classroomId:number):Observable<StudyMaterialResponse>{
		return this.http.get<StudyMaterialResponse>(`${this.apiUrl}/all/${classroomId}`);
	}

	getAllStudentAnnouncement(classroomId:number): Observable<StudentStudyMaterialResponse> {
		const params= new HttpParams().set('class_id',classroomId)
		return this.http.get<StudentStudyMaterialResponse>(`${this.apiUrl}/student`,{params});
	}

}